<template>
  <div class="main">

      <div class="tutorial-content-wrapper">
        <!-- <h3>Risk Analysis Example? <TextToSpeechSimple :inputText="ttsIntro"></TextToSpeechSimple></h3> -->
        <!-- <p>{{interactionNeeded ? 'This is an interactive page' : 'This is a static page'}}</p> -->
        <!-- <button class="button is-primary" @click="sendData">Interact</button> -->

        <!-- <hr> -->

        <!-- ===================================================================================================================== -->

        <div class="step-wrapper">


           <div class="step-progress">

             <ul class="steps is-horizontal is-small">
                <li class="steps-segment" :class="{'is-active':step === 1}">
                  <span class="steps-marker">1</span>
                </li>
                <li class="steps-segment" :class="{'is-active':step === 2}">
                  <span class="steps-marker">2</span>
                </li>
                <li class="steps-segment" :class="{'is-active':step === 3}">
                  <span class="steps-marker">3</span>
                </li>
                <li class="steps-segment" :class="{'is-active':step === 4}">
                  <span class="steps-marker">4</span>
                </li>
                <li class="steps-segment" :class="{'is-active':step === 5}">
                  <span class="steps-marker">5</span>
                </li>
                <li class="steps-segment" :class="{'is-active':step === 6}">
                  <span class="steps-marker">6</span>
                </li>
              </ul>

           </div>

            <div class="steps-content">


              <transition :name="transitionName">

                   <div class="slide-section" v-if="step === 1">

                      <h2 class="has-text-centered">1. Identify a hazard <TextToSpeechSimple :inputText="ttsIdentifyHazard"></TextToSpeechSimple></h2>
                      <h6>A hazard is a part of your vessel or something that happens on your vessel that could cause someone to get hurt.</h6>

                      <div class="buttons">
                        <button @click="writeHazards = true" class="button is-warning is-medium">{{selectedHazard != '' ? 'Edit your hazard' : 'Write your own hazard'}}</button>
                        <button @click="showHelperHazards = true" class="button is-primary is-medium">{{selectedHazard != '' ? 'Choose another hazard' : 'Or choose a helper hazard'}}</button>
                      </div>

                      <div class="spacer s20"></div>
                      <div v-if="selectedHazard != ''" class="small-title">
                        <span>Hazard:</span>{{selectedHazard}}
                      </div>
                      <div class="spacer s20"></div>

                      <div class="clear"></div>

                  </div>

              </transition>


              <transition :name="transitionName">

                   <div class="slide-section" v-if="step === 2">

                      <h2 class="has-text-centered">2. What are the risks?  <TextToSpeechSimple :inputText="ttsRisks"></TextToSpeechSimple></h2>
                      <h6>What could happen or how could someone get hurt from the hazard<!--  <span>{{selectedHazard}}</span> -->.</h6>

                      <div class="buttons">
                        <button @click="writeRisks = true" class="button is-warning is-medium">{{finalRisks != '' ? 'Edit the risks' : 'Write your own risks'}}</button>
                        <button @click="showHelperRisks = true" class="button is-primary is-medium">{{finalRisks != '' ? 'Choose different risks' : 'Or choose some helper risks'}}</button>
                      </div>

                      <div class="spacer s20"></div>
                      <div class="small-title">
                          <div><span>Hazard:</span>{{selectedHazard}}</div>
                          <div v-if="finalRisks != ''"><span>RISKS:</span>{{joinedRisks}}</div>
                      </div>
                      <div class="spacer s20"></div>

                      <div class="clear"></div>

                  </div>

              </transition>


              <transition :name="transitionName">

                  <div class="slide-section" v-if="step === 3">

                      <h2 class="has-text-centered">3. What can you do to prevent this from happening?   <TextToSpeechSimple :inputText="ttsControls"></TextToSpeechSimple></h2>
                      <h6>We use the word <span>controls</span> to talk about the actions you can take to prevent a hazard from causing injury.</h6>

                      <div class="buttons">
                        <button @click="writeControls = true" class="button is-warning is-medium">{{joinedControls ? 'Edit what you can do' : 'Write what you can do'}}</button>
                        <button @click="showHelperControls = true" class="button is-primary is-medium">{{joinedControls ? 'Choose other helper controls' : 'Or choose a helper control'}}</button>
                      </div>

                      <div class="spacer s40"></div>
                      <div class="small-title">
                        <div><span>Hazard:</span>{{selectedHazard}}</div>
                        <div><span>RISKS:</span>{{joinedRisks}}</div>
                        <div v-if="joinedControls"><span>CONTROLS:</span>{{joinedControls}}</div>

                      </div>
                      <div class="spacer s40"></div>

                      <div class="clear"></div>

                  </div>

              </transition>


              <transition :name="transitionName">

                  <div class="slide-section" v-if="step === 4">

                      <h2 class="has-text-centered">4. Policies and Procedures.  <TextToSpeechSimple :inputText="ttsPolicies"></TextToSpeechSimple></h2>
                      <h6>This is also a good time to write a new vessel <span>policy</span> or create a new <span>procedure</span> around this hazard.</h6>

                      <div class="buttons">
                        <button @click="writePolicy = true" class="button is-info is-medium">{{newPolicy.title ? 'Edit your Policy' : 'Write a new vessel policy'}}</button>
                        <button @click="writeProcedure = true" class="button is-dark is-medium">{{newProcedure.title ? 'Edit your Procedure' : 'Write a new work procedure'}}</button>
                      </div>

                      <div class="spacer s40"></div>
                      <div class="small-title">
                        <div><span>Hazard:</span>{{selectedHazard}}</div>
                        <div><span>RISKS:</span>{{joinedRisks}}</div>
                        <div v-if="joinedControls"><span>CONTROLS:</span>{{joinedControls}}</div>
                        <div v-if="newPolicy.title"><span>New Policy:</span>{{newPolicy.title}}</div>
                        <div v-if="newPolicy.title && newPolicy.details"><span>Policy Details:</span>{{newPolicy.details}}</div>
                        <div v-if="newProcedure.title"><span>New Procedure:</span>{{newProcedure.title}}</div>
                        <div v-if="newProcedure.title && newProcedure.details"><span>Procedure Details:</span>{{newProcedure.details}}</div>

                      </div>
                      <div class="spacer s40"></div>

                      <div class="clear"></div>

                  </div>

              </transition>


              <transition :name="transitionName">

                  <div class="slide-section" v-if="step === 5">

                      <h2 class="has-text-centered">5. Let's rate this hazard <TextToSpeechSimple :inputText="ttsRating"></TextToSpeechSimple></h2>
                      <h6>This simply tells us how serious this hazard is. Use the fields below to find out the risk rating. </h6>

                      <div class="notification">
                        <toggle-rating 
                          v-on:sendRatingData="getRatingData" 
                          :savedLikelihood="newLikelihood" 
                          :savedConsequence="newConsequence" 
                          :savedRating="newRating" 
                        ></toggle-rating>
                      </div>

                      <!-- <div class="spacer s20"></div> -->
                      <!-- <div class="small-title">
                        <div><span>Hazard:</span>{{selectedHazard}}</div>
                        <div><span>RISKS:</span>{{joinedRisks}}</div>
                        <div v-if="joinedControls"><span>CONTROLS:</span>{{joinedControls}}</div>
                        <div v-if="newPolicy.title"><span>New Policy:</span>{{newPolicy.title}}</div>
                        <div v-if="newProcedure.title"><span>New Procedure:</span>{{newProcedure.title}}</div>
                        <div v-if="newRating"><span>Risk rating:</span><span class="rating">{{newRating}}</span></div>

                      </div> -->
                      <div class="spacer s20"></div>

                      <div class="clear"></div>
                 
                  </div>

              </transition>     


              <transition :name="transitionName">

                  <div class="slide-section" v-if="step === 6">

                      <h2 class="has-text-centered">6. Lastly, who is responsible? <TextToSpeechSimple :inputText="ttsResponsible"></TextToSpeechSimple></h2>
                      <h6>Who should make sure that the risk controls are followed for this hazard?</h6>

                      <div class="checkbox-wrapper centered">
                        <div class="field" v-for="person in persons" :key="person">
                          <input class="is-checkradio" type="checkbox" :id="person" :value="person" v-model="selectedPeople">
                          <label :for="person">{{person}}</label>
                        </div>
                      </div>

                      <div class="clear"></div>
                 
                  </div>

              </transition>    


              <transition :name="transitionName">

                  <div class="slide-section" v-if="step === 7">

                      <h2 class="has-text-centered">Nice work! <TextToSpeechSimple :inputText="ttsFinished"></TextToSpeechSimple></h2>
                      <h6>You have completed a risk assessment (see summary below). This is how you should assess every hazard on your vessel and in your operation.</h6>

                      <div class="spacer s20"></div>
                      <div class="small-title">
                        <div><span>Hazard:</span>{{selectedHazard}}</div>
                        <div><span>RISKS:</span>{{joinedRisks}}</div>
                        <div v-if="joinedControls"><span>CONTROLS:</span>{{joinedControls}}</div>
                        <div v-if="newPolicy.title"><span>New Policy:</span>{{newPolicy.title}}</div>
                        <div v-if="newPolicy.title && newPolicy.details"><span>Policy Details:</span>{{newPolicy.details}}</div>
                        <div v-if="newProcedure.title"><span>New Procedure:</span>{{newProcedure.title}}</div>
                        <div v-if="newProcedure.title && newProcedure.details"><span>Procedure Details:</span>{{newProcedure.details}}</div>
                        <div v-if="newRating"><span>Risk rating:</span><span class="rating">{{newRating}}</span></div>
                        <div v-if="joinedPeople"><span>Who's responsible?</span>{{joinedPeople}}</div>

                      </div>
                      <div class="spacer s20"></div>

                      <img class="smiley" src="../assets/popeye.jpg" alt="Offshore SMS">
                      <h4>Click on the Next button below.</h4>
                      <div class="spacer s40"></div>

                      <div class="clear"></div>
                 
                  </div>

              </transition>    






              <div class="clear"></div>

            </div>

          </div>

          <hr>

          <div class="buttons nextPrev">
            <button v-if="step > 1" class="button is-info previous" @click.prevent="prev()"> <span><font-awesome-icon icon="chevron-left" /></span> Step {{step - 1}}</button>
            <button :disabled="!canProceed" v-if="step < totalSteps" class="button is-info next" @click.prevent="next()">Step {{step + 1}} <span><font-awesome-icon icon="chevron-right" /></span></button>
          </div>

        <!-- ===================================================================================================================== -->

      </div>



      <!-- HAZARDS ================================================================= -->
      <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{'is-active':writeHazards}">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Write a hazard</p>
            <button class="delete" aria-label="close" @click.prevent="close"></button>
          </header>
          <section class="modal-card-body"> 

            <textarea class="input" placeholder="Write your own hazard here..." v-model="selectedHazard"></textarea>

          </section>
          <footer class="modal-card-foot">
           <!--  <button class="button is-primary" @click="saveHelperItems">{{selectedItems.length > 0 ? 'Update Items' : 'Add helper Items'}}</button> -->
            <button class="button is-primary" @click.prevent="close">Save hazard</button>
          </footer>
        </div>
      </div>


      <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{'is-active':showHelperHazards}">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Choose a hazard</p>
            <button class="delete" aria-label="close" @click.prevent="close"></button>
          </header>
          <section class="modal-card-body"> 

            <div class="checkbox-wrapper">
              <div class="field" v-for="item in helperHazards" :key="item.id">
                <input class="is-checkradio" type="radio" :id="item.id" :value="item.title" v-model="selectedHazard">
                <label :for="item.id">{{item.title}}</label>
              </div>
            </div>

          </section>
          <footer class="modal-card-foot">
           <!--  <button class="button is-primary" @click="saveHelperItems">{{selectedItems.length > 0 ? 'Update Items' : 'Add helper Items'}}</button> -->
            <button class="button is-primary" @click.prevent="close">Use this hazard</button>
          </footer>
        </div>
      </div>



      <!-- RISKS ================================================================= -->
      <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{'is-active':writeRisks}">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Write a risk</p>
            <button class="delete" aria-label="close" @click.prevent="close"></button>
          </header>
          <section class="modal-card-body"> 

            <textarea class="input" placeholder="Write what could happen here..." v-model="finalRisks"></textarea>

          </section>
          <footer class="modal-card-foot">
            <button class="button is-primary" @click="close">Done</button>
            <!-- <button class="button is-primary" @click.prevent="close">Save risk</button> -->
          </footer>
        </div>
      </div>


      <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{'is-active':showHelperRisks}">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Choose some risks</p>
            <button class="delete" aria-label="close" @click.prevent="close"></button>
          </header>
          <section class="modal-card-body"> 

            <div class="checkbox-wrapper">
              <div class="field" v-for="item in helperRisks" :key="item.id">
                <input class="is-checkradio" type="checkbox" :id="item.id" :value="item.title" v-model="selectedRisks">
                <label :for="item.id">{{item.title}}</label>
              </div>
            </div>

          </section>
          <footer class="modal-card-foot">
            <!-- <button class="button cancel" @click.prevent="close">Cancel</button> -->
            <button class="button is-primary" @click="saveHelperRisks">Done</button>
          </footer>
        </div>
      </div>



      <!-- CONTROLS ================================================================= -->
      <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{'is-active':writeControls}">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Write a control</p>
            <button class="delete" aria-label="close" @click.prevent="close"></button>
          </header>
          <section class="modal-card-body"> 

            <textarea class="input" placeholder="Write what you could do to prevent the risk..." v-model="finalControls"></textarea>

          </section>
          <footer class="modal-card-foot">
            <button class="button is-primary" @click="close">Done</button>
            <!-- <button class="button is-primary" @click.prevent="close">Save risk</button> -->
          </footer>
        </div>
      </div>


      <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{'is-active':showHelperControls}">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Choose some control methods</p>
            <button class="delete" aria-label="close" @click.prevent="close"></button>
          </header>
          <section class="modal-card-body"> 

            <div class="checkbox-wrapper">
              <div class="field" v-for="item in helperControls" :key="item.id">
                <input class="is-checkradio" type="checkbox" :id="item.id" :value="item.title" v-model="selectedControls">
                <label :for="item.id">{{item.title}}</label>
              </div>
            </div>

          </section>
          <footer class="modal-card-foot">
            <!-- <button class="button cancel" @click.prevent="close">Cancel</button> -->
            <button class="button is-primary" @click="saveHelperControls">Done</button>
          </footer>
        </div>
      </div>


      <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{'is-active':writePolicy}">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Write a new vessel policy</p>
            <button class="delete" aria-label="close" @click.prevent="close"></button>
          </header>
          <section class="modal-card-body">       
            <div class="form-group">      
              <input class="input" type="text" placeholder="Write the policy name..." v-model="newPolicy.title" required>
              <!-- <span class="highlight"></span>
              <span class="bar"></span>
              <label>Policy Title:</label> -->
            </div>
            <div class="form-group">      
              <textarea rows="3" placeholder="Policy details here..." class="input" v-model="newPolicy.details"></textarea>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-primary" @click="saveNewPolicy">Done</button>
            <button class="button cancel" @click.prevent="newPolicy = {}">Clear</button>
          </footer>
        </div>
      </div>


      <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{'is-active':writeProcedure}">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Write new operating procedure:</p>
            <button class="delete" aria-label="close" @click.prevent="close"></button>
          </header>
          <section class="modal-card-body">       
            <div class="form-group">      
              <input class="input" type="text" placeholder="Write the procedure name..." v-model="newProcedure.title" required>
              <!-- <span class="highlight"></span>
              <span class="bar"></span>
              <label>Procedure Title:</label> -->
            </div>
            <div class="form-group">      
              <textarea rows="3" placeholder="Procedure details here..." class="input" v-model="newProcedure.details"></textarea>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-primary" @click="saveNewProcedure">Done</button>
            <button class="button cancel" @click.prevent="newProcedure = {}">Clear</button>
          </footer>
        </div>
      </div>



      

      <div class="bottom-spacer"></div>
      <div class="bottom-spacer"></div>


  </div>
</template>


<script>

import { db } from '../main.js';
import TextToSpeechSimple from '../components/TextToSpeechSimple.vue';
const ToggleRating = () => import('../components/ToggleRating.vue');

export default {

  components: {
      TextToSpeechSimple,
      ToggleRating,
  },

  props: [
      'interactionNeeded',
  ],

  mounted() {
    this.loadHelperItems();
  },

  computed: {
    canProceed() {
      let self = this;
      switch(self.step) {
        case 1:
          return this.selectedHazard == '' ? false : true;
        case 2:
          return this.finalRisks == '' ? false : true;
        case 3:
          return this.joinedControls ? true : false;
        case 4:
          return !this.newPolicy.title && !this.newProcedure.title ? false : true;
        case 5:
          return !this.newRating ? false : true;
        case 6:
          return true;
        case 7:
          return true;
        default:
          return false;
      }
    },
    joinedRisks() {
      let tempRisks = this.finalRisks.split('\n');
      return tempRisks.join(', ');
    },
    joinedControls() {
      let tempControls = this.finalControls.split('\n');
      return tempControls.join(', ');
    },
    joinedPeople() {
      // let tempPeople = this.finalPeople.split('\n');
      return this.selectedPeople.join(', ');
    },
  },

  watch: {
    step() {
      if(this.step == 7) {
        this.sendData();
      }
    }
  },

  data() {
    return {
      hasInteracted: false,
      currentIndex: 0,
      ttsIntro: 'Let\'s do a risk assessment on vessel, AB TAXI.',
      ttsIdentifyHazard: 'Start by identifying a hazard. A hazard is a part of your vessel, or something that happens on your vessel, that could cause someone to get hurt.',
      ttsRisks: 'What are the risks? What could happen, or how could someone get hurt?',
      ttsControls: 'What can you do to prevent this from happening? We use the word, Controls, to talk about the actions you can take, to prevent a hazard from causing injury.',
      ttsPolicies: 'This is also a good time to write a new vessel policy, or create a new safe operating procedure around this hazard.',
      ttsRating: 'Let\'s rate this hazard. This simply tells us how serious this hazard is. Use the fields below to find out the risk rating.',
      ttsResponsible: 'Who should make sure that the risk controls are followed for this hazard?',
      ttsFinished: 'Nice work! You have completed a risk assessment. This is how you should assess every hazard on your vessel and in your operation.',
      step: 1,
      totalSteps: 7,
      transitionName: 'slide-right',
      hazard: {
        name: '',
      },

      selectedHazard: '',
      helperHazards: [],
      writeHazards: false,
      showHelperHazards: false,
      
      selectedRisks: [],
      finalRisks: '',
      helperRisks: [],
      writeRisks: false,
      showHelperRisks: false,
      
      selectedControls: [],
      finalControls: '',
      helperControls: [],
      writeControls: false,
      showHelperControls: false,

      upToDate: false,

      writeProcedure: false,
      writePolicy: false,
      newPolicy: {},
      newProcedure: {},
      
      selectedRating: '',
      newLikelihood: [],
      newConsequence: [],
      newRating: '',

      responsiblePerson: '',
      selectedPeople: [],
      finalPeople: '',
      persons: [
        'The vessel Owner','The vessel Master','The crew','Everybody on board'
      ]

    }
  },

  methods: {

    loadHelperItems() {
      var self = this;

      db.collection("helperHazards").orderBy("key","asc").onSnapshot(function(querySnapshot) {
        self.helperHazards = [];
        querySnapshot.forEach(function(doc) {
          self.helperHazards.push({
            id: doc.id,
            title: doc.data().title,
            key: doc.data().key,
            show: doc.data().key == 0 ? true : false,
            // details: doc.data().details
          });
        });
      });

      db.collection("helperRisks").orderBy("key","asc").onSnapshot(function(querySnapshot) {
        self.helperRisks = [];
        querySnapshot.forEach(function(doc) {
          self.helperRisks.push({
            id: doc.id,
            title: doc.data().title,
            key: doc.data().key,
            show: doc.data().key == 0 ? true : false,
            // details: doc.data().details
          });
        });
      });

      db.collection("helperControls").orderBy("key","asc").onSnapshot(function(querySnapshot) {
        self.helperControls = [];
        querySnapshot.forEach(function(doc) {
          self.helperControls.push({
            id: doc.id,
            title: doc.data().title,
            key: doc.data().key,
            show: doc.data().key == 0 ? true : false,
            // details: doc.data().details
          });
        });
      });


    },

    saveHelperRisks: function() {
      var self = this;
      self.finalRisks = [];
      this.selectedRisks.forEach((risk, index) => {
        if (self.selectedRisks.length == index + 1) {
          self.finalRisks += risk;
        } else {
          self.finalRisks += risk + "\n";
        }
      });
      this.selectedRisks = [];
      this.showHelperRisks = false;          
    },

    saveHelperControls: function() {
      var self = this;
      self.finalControls = [];
      this.selectedControls.forEach((control, index) => {
        if (self.selectedControls.length == index + 1) {
          self.finalControls += control;
        } else {
          self.finalControls += control + "\n";
        }
      });
      this.selectedControls = [];
      this.showHelperControls = false;          
    },

    saveNewPolicy: function() {
      this.writePolicy = false;
    },

    saveNewProcedure: function() {
      this.writeProcedure = false;
    },

    setHelperHazard: function() {
      this.showHelperHazards = false;
    },

    getRatingData: function(result) {
      //console.log('Ratings Data:',result);
      this.newLikelihood = result[0];
      this.newConsequence = result[1];
      this.newRating = result[2];
      // this.editingHazard.newRating = result[2];
    },

    prev() {
      window.scrollTo(0, 0);
      this.transitionName = 'slide-right';
      this.step--;
    },

    next() {
      // this.canProceed();
      window.scrollTo(0, 0);
      this.transitionName = 'slide-left';
      this.step++;
    },

    close: function() {
      this.showHelperHazards = false;
      this.writeHazards = false;
      this.showHelperRisks = false;
      this.writeRisks = false;
      this.showHelperControls = false;
      this.writeControls = false;
      this.writeProcedure = false;
      this.writePolicy = false;
    },

    goBack: function() {
      console.log('Router',this.$router);
      this.$router.go(-1);
    },

    sendData: function() {
      let self = this;
      self.hasInteracted = true;
      let result = {
        hasInteracted: self.hasInteracted,
      }
      this.$emit('sendData', result)
    },
    
  }
}
</script>



<style lang="scss" scoped>

  // button {
  //   margin-top: 1rem;
  // }

  .slide-fade-enter-active {
    transition: all .5s ease;
  }
  .slide-fade-leave-active {
    //transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(100%);
    opacity: 0;
  }


.slide-left-enter {
  opacity: 0;
  transform: translateX(100%);
}
.slide-left-enter-active {
  transition: 0.5s ease-in;
}
.slide-left-enter-to {
  transform: scale3d(1, 1, 1);
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(-100%);
}
.slide-right-enter-active {
  transition: 0.5s ease-in;
}
.slide-right-enter-to {
  transform: scale3d(1, 1, 1);
}
.slide-right-leave {
  transition: 0.5s ease-out;
}

  h2 {
    margin-top: 2rem;
  }

  h6 {
    margin: 1rem auto 2rem;
    font-size: 1.2rem;
    line-height: 1.4rem;
    max-width: 600px;
    span {
      color: red;
      text-transform: uppercase;
    }
  }

  .checkbox-wrapper.centered {
    width: 100%;
    max-width: 250px;
    margin: 1rem auto;
    border: none;
  }

  .buttons {
    text-align: center;
    margin: 0 auto;
    display: block;
    width: 100%;
    position: relative;
    &.nextPrev {
      margin-bottom: 5rem;
      text-align: left;
      .button {
        position: absolute;
        top: 0;
        &.next {
          right: 0;
          span {
            margin-left: 5px;
          }
        }
        &.previous {
          left: 0;
          span {
            margin-right: 5px;
          }
        }
      }
      &.center {
        text-align: center;
      }
    }
    .button {
      &.is-medium {
        padding: 16px 25px;
        height: auto;
      }
    }
  }

  .step-wrapper {
    margin-top: 2rem;
    .step-progress {
      display: none;
      margin: 1rem 0;
      padding-bottom: 0.5rem;
      .steps-segment {
        cursor: pointer;
      }
    }
    .steps-content {

    }
  }

  .spacer {
    &.s10 {
      height: 10px;
      width: 100%;
    }
    &.s20 {
      height: 20px;
      width: 100%;
    }
    &.s40 {
      height: 40px;
      width: 100%;
    }
  }

  .small-title {
    width: 100%;
    padding: 10px 10px 10px 25px;
    // margin: 2rem auto 3rem;
    background: #f4f4f4;
    border-radius: 3px;
    text-align: left;
    &.hazard {
      color: white;
      background: #ff3860;
    }
    span {
      margin-right: 7px;
      font-weight: bold;
      text-transform: uppercase;
      &.rating {
        font-weight: normal;
      }
    }
  }
    

  textarea {
    min-height: 140px;
    margin: 1rem 0 1rem;
  }

  .buttons.rating {
    display: block;
    text-align: center;
    .button {
      &.low.active {
        background: #23d160;
      }
      &.medium.active {
        background: #ffdd57;
      }
      &.high.active {
        background: #ff3860;
      }
    }
  }




</style>